import React, {useEffect, useState} from 'react';
import {Card, Col, Flex, message, Row, Tag} from "antd";
import IntlMessage, {IntlMessageText} from "../../../../../components/IntlMessage/IntlMessage";
import {useDispatch, useSelector} from "react-redux";
import {getUserByToken} from "../../../../../store/slices/userSlice";
import {clrs} from "../../../../../constants/colors";
import MyText from "../../../../../components/UI/Text/MyText";
import {LocalName} from "../../../../../utils/LocalName";
import {RightOutlined} from "@ant-design/icons";
import GroupService from "../../../../../services/GroupService";
import {useNavigate} from "react-router-dom";
import BlockLoading from "../../../../../components/LoadingComponents/BlockLoading";

const TeacherHomePage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {user, isLoading} = useSelector(state => state.user);
    const [journals, setJournals] = useState([])
    const [isGroupsLoading, setIsGroupsLoading] = useState(false)
    const [conductedClasses, setConductedClasses] = useState(0)
    useEffect(() => {
        if (user === null) {
            dispatch(getUserByToken());
        }
        handleFetchData();
    }, []);

    async function handleFetchData() {
        setIsGroupsLoading(true);
        await GroupService.getConductedClassesByTeacher(user.id)
            .then((r) => {
                setJournals(r)
            })
            .catch(() => {
                message.destroy();
                message.error(<IntlMessage id={'error'}/>, 5);
            })
            .finally(() => {
                setIsGroupsLoading(false);
            })
    }

    function getNumberOfStudents() {
        return journals.reduce((sum, item) => {
            return sum + (item.journal.group?.students?.length || 0);
        }, 0);
    }

    function getNumberOfConductedClasses() {
        return journals.reduce((sum, item) => {
            return sum + (item?.journal?.lessonWithDate || 0);
        }, 0);
    }

    function getPercentageOfConductedLessonsOfJournal(item) {
        if (!item.journal?.lessons?.length) return 0;
        return Math.round((item?.journal?.lessonWithDate / item.journal.lessons.length) * 100);
    }

    function formatPhoneNumber(phone) {
        if (!phone || phone.length !== 11) return phone;

        return `+7 ${phone.slice(1, 4)} ${phone.slice(4, 7)} ${phone.slice(7)}`;
    }

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <BlockLoading style={{width: "100%"}} isLoading={isGroupsLoading}/>
            <Flex style={{
                width: "100%",
                position: "relative",
                padding: 20,
                border: `1px solid ${clrs.whiter2}`,
                borderRadius: 10,
                backgroundColor: clrs.white
            }} justify={"space-between"} align={"center"}>
                <Flex vertical gap={10}>
                    <MyText black size={"big"}>{user.profile.fullName}</MyText>
                    <Flex vertical gap={4}>
                        <MyText medium size={"small"}
                                style={{color: clrs.whiterBlacker}}>{user.profile.email}</MyText>
                        <MyText medium size={"small"}
                                style={{color: clrs.whiterBlacker}}>{formatPhoneNumber(user.profile.telNumber)}</MyText>
                        <MyText medium style={{color: clrs.whiterBlacker}}
                                size={"small"}>{user.profile.birthDay && IntlMessageText.getText({id: "birthDay"}) + ": " + new Date(user.profile.birthDay).toLocaleDateString('kk-KZ')}</MyText>
                    </Flex>
                </Flex>
                <Tag style={{padding: 6, borderRadius: 20, fontWeight: 600}} bordered={false} color={"blue"}>
                    <IntlMessage id={user.role.roleName}/>
                </Tag>
            </Flex>

            {/* ТУТ НАДО СДЕЛАТЬ */}
            <Flex style={{
                width: "100%",
                position: "relative",
                padding: 20,
                border: `1px solid ${clrs.whiter2}`,
                borderRadius: 10,
                background: "linear-gradient(90deg, rgba(74,105,255,1) 0%, rgba(37,168,247,1) 100%)",
                color: clrs.white
            }} justify={"center"} align={"flex-start"} vertical gap={20}>
                <MyText black size={"big"}><IntlMessage id={"tg.dayQuote"}/></MyText>
                <MyText italic size={"default"}>“The more that you read, the more things you will know, the more that
                    you learn, the more places you’ll go.”</MyText>
                <MyText style={{alignSelf: "flex-end"}} size={"default"}>- Dr. Seuss</MyText>
            </Flex>
            <Flex style={{width: '100%'}} gap={"middle"}>
                <Flex flex={1} style={{
                    width: '100%',
                    position: "relative",
                    padding: 20,
                    border: `1px solid ${clrs.whiter2}`,
                    borderRadius: 10,
                    backgroundColor: clrs.white
                }} justify={"center"} align={"center"} vertical>
                    <MyText black>{journals.length}</MyText>
                    <MyText style={{color: clrs.whiterBlacker}}><IntlMessage id={"ordersPage.groups"}/></MyText>
                </Flex>
                <Flex flex={1} style={{
                    width: '100%',
                    position: "relative",
                    padding: 20,
                    border: `1px solid ${clrs.whiter2}`,
                    borderRadius: 10,
                    backgroundColor: clrs.white
                }} justify={"center"} align={"center"} vertical>
                    <MyText black>{getNumberOfStudents()}</MyText>
                    <MyText style={{color: clrs.whiterBlacker}}><IntlMessage id={"ordersPage.students"}/></MyText>
                </Flex>
                <Flex flex={1} style={{
                    width: '100%',
                    position: "relative",
                    padding: 20,
                    border: `1px solid ${clrs.whiter2}`,
                    borderRadius: 10,
                    backgroundColor: clrs.white
                }} justify={"center"} align={"center"} vertical>
                    <MyText black>{getNumberOfConductedClasses()}</MyText>
                    <MyText style={{color: clrs.whiterBlacker}}><IntlMessage id={"conductedLessons"}/></MyText>
                </Flex>
            </Flex>
            <Flex style={{width: "100%", position: "relative"}} align={"flex-start"} justify={"flex-start"} wrap={"wrap"} gap={"middle"}>
                {
                    journals.map((item) => (
                        <Card style={{width: "calc(100%/3 - 10.7px)"}}>
                            <Flex vertical gap={20} align={"flex-start"} justify={"center"}>
                                <MyText>{LocalName.getName(item.journal.group) + " " + item.journal.group.number}</MyText>
                                <MyText><IntlMessage id={"conductedLessons2"}/> {item?.journal?.lessonWithDate} <IntlMessage id={"in"}/> {item.journal.lessons.length}</MyText>
                                <ProgressBar percentage={getPercentageOfConductedLessonsOfJournal(item)}/>
                                <MyText onClick={() => navigate(`/p/group/${item.journal.group.id}`)} style={{
                                    alignSelf: "flex-end",
                                    cursor: "pointer",
                                    color: clrs.blueForIcon
                                }}><IntlMessage
                                    id={"journal"}/><RightOutlined/></MyText>
                            </Flex>
                        </Card>
                    ))
                }
            </Flex>
            <Row style={{width: '100%'}} gutter={[16, 16]} align={"middle"} justify={"start"}>

                <Col span={8}/>
            </Row>
        </Flex>
    );
};

const ProgressBar = ({percentage}) => {
    return (
        <Flex style={{width: '100%'}} align={"center"} justify={"center"} vertical>
            <div style={{
                height: '12px',
                width: '100%',
                backgroundColor: '#e0e0e0',
                borderRadius: '6px',
                overflow: 'hidden'
            }}>
                <div style={{
                    height: '100%',
                    width: `${percentage}%`,
                    backgroundColor: '#296CFF',
                    transition: 'width 0.3s ease-in-out'
                }}/>
            </div>
            <span style={{alignSelf: "flex-end", color: '#4d6b8b', fontSize: '14px'}}>{percentage}%</span>
        </Flex>
    );
};

export default TeacherHomePage;